import { createFileRoute } from "@tanstack/react-router";
import { LoginComponent } from "../../features/auth/components/LoginComponent";

export const Route = createFileRoute("/_auth/login")({
  validateSearch: (search) => ({
    redirect: search.redirect,
  }),
  component: LoginComponent,
});
